module.exports = __webpack_public_path__ + "img/instruction_2.3d14fa3b.jpg";